<script setup>
import { Link, useForm } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import HotelSubMenu from '@/Includes/HotelSubMenu.vue';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'
import { useToast } from 'vue-toast-notification';
import { ref, onMounted } from "vue";
import { Modal } from 'bootstrap';
import { VueMultiImageUpload } from '@zakerxa/vue-multiple-image-upload';
import Loading from 'vue-loading-overlay';

const props = defineProps({
    year: String,
    hotelsById: Object,
    gallery: Object,
    flash: Object,
    user: Object,
});
let menu = 'gallery';
const $toast = useToast();
let modalShow = ref(null);
let thisModalObj = null;
let component = {};
let img = null;
let isLoading = ref(false);
const imageType = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'];
const options = {
    max: 'Maximum',
}

onMounted(() => {
    thisModalObj = new Modal(modalShow.value);
});

const ImageUploadform = useForm({
    hotel_images: [],
    hotel_id: props.hotelsById.id,
});

const images = (e) => {
    let inputImages = e;
    ImageUploadform.hotel_images = inputImages;
};

const ImageUploadformSubmit = () => {
    ImageUploadform.post('/hotels/uploadimages', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide(),
                $toast.open({
                    message: props.flash.message,
                    type: "info",
                    duration: 4000,
                    position: 'top-right',
                    class: 'bs-toast toast bg-dark show'
                });
        }
    });
};

function deleteImage(value) {
    new Swal({
        title: 'Are you sure?',
        text: "All the data related to this image will be deleted!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'I am sure!'
    }).then((result) => {
        if (result.isConfirmed) {
            setTimeout(() => {
                window.location.href = '/hotels/removeimage/' + value + '/' + props.hotelsById.id;
            }, 300);
            $toast.success('Image deleted successfully!', {
                position: 'top-right',
                duration: 4000,
                hideProgressBar: true,
                icon: true,
                type: "info",
                class: 'bs-toast toast bg-dark show'
            });
        }

    })
}

function clear() {
    component.clear = true;
}

</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import "vue-loading-overlay/dist/vue-loading.css";
</style>
<template>
    <AppLayout title="Hotel Gallery" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <HotelSubMenu :hotelsById="hotelsById" :menu="menu" />
            <div class="row g-0">
                <div class="card">
                    <h5 class="card-header">Hotel Gallery</h5>
                    <div class="card-body">
                        <div class="row row-cols-1 row-cols-md-6 g-4 mb-5">
                            <div class="col" v-for="images in props.gallery" :key="images.id">
                                <div class="card">
                                    <img :src="'/fetch-galleryPhotos/' + images + '?w=203&h=203&fit=crop'"
                                        :alt="hotelsById.name" class="card-img-top" />
                                    <div class="card-body text-center"
                                        v-if="$page.props.user.permissions.includes('remove-images-from-hotel')">
                                        <Link type="button" class="btn btn-outline-danger" href="#"
                                            @click="deleteImage(images.split('/')[0])" preserve-state preserve-scroll>
                                        <i class="bx bx-message-square-x"></i> Delete
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="uploadsModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Upload Images</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="ImageUploadformSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col mb-3">
                                    <label for="name" class="form-label"><b>Images</b></label>
                                    <VueMultiImageUpload @dataImage="images" :max="5" :imageSize="2e6"
                                        :dataReset="component" :accept="imageType" :options="options"
                                        name="hotel_images"
                                        :class="{ 'is-invalid': ImageUploadform.errors.hotel_images }" />
                                    <div v-if="ImageUploadform.errors.hotel_images" class="invalid-feedback">
                                        <div v-text="ImageUploadform.errors.hotel_images">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" data-bs-dismiss="modal">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Upload</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </AppLayout>
</template>